import { Box, Flex, useTheme, Link, Image } from '@chakra-ui/react';
import MsrSectionTitle from '@msr/components/Headings/MsrSectionTitle';
import NextLink from 'next/link';
import React from 'react';
import config from '@config';
import { refineUrlDomain } from '@msr/components/Utility/utils';

/* Internal Components */
/* Components */
import StructuredTextContent from '@components/UI/StructuredTextContent';

const FunActivities = ({ sectionContent, lang }) => {
  const theme = useTheme();
  const spacing = theme.space[5];
  return (
    <Box
      bgColor={'blue.400'}
      p={{ base: '0px 0px 20px 0px', lg: '0px 20px 60px 20px' }} className='funactivities'
    >
      <Box maxW={'1330px'} m="0 auto" display={'flex'}>
        <Box>
          <Image
            src={`${config.imgPath}/d/46272/1739770493-pngwing1.png`}
            alt=""
            width={{ base: '70%', md: '100%' }}
          />
        </Box>
        <Box display={{ base: 'none', md: 'block' }}>
          <Image
            src={`${config.imgPath}/d/46272/1739770493-pngwing3.png`}
            alt=""
          />
        </Box>
        <Box display={{ base: 'none', md: 'block' }}>
          <Image
            src={`${config.imgPath}/d/46272/1739770493-pngwing4.png`}
            alt=""
          />
        </Box>
        <Box textAlign={'right'}>
          <Image
            src={`${config.imgPath}/d/46272/1739856210-pngwing2.png`}
            alt=""
            width={{ base: '70%', md: '100%' }}
          />
        </Box>
      </Box>
      <Box
        maxW={{ base: '210px', md: '370px' }}
        m={{ base: '0px auto 0 auto', md: '-50px auto 0 auto' }}
      >
        <MsrSectionTitle
          pt="0"
          fontFamily={'FedraSerifAStdBook'}
          fontWeight={'500'}
          mt="0"
          titleObj={sectionContent[0]}
        />
      </Box>
      <Box m={{ base: '30px auto', md: '50px auto 0 auto' }} h="100%">
        <Box m="0 auto" maxW={'990px'}>
          <Flex
            flexWrap="wrap"
            justifyContent="center"
            marginX={{base:'', md:`calc(${spacing} / -1)`}}
            flexDir={{ base: 'column', md: 'row' }}
          >
            {sectionContent[1]?.cards?.map((secCon, index) => {
              return (
                <Flex
                  flexGrow="0"
                  flexDirection="column"
                  flexShrink="0"
                  flexBasis={`calc(33% - ${spacing})`}
                  marginBottom={spacing}
                  _even={{
                    marginX: spacing,
                  }}
                  py={{ base: '0', md: '5px' }}
                >
                  <Flex
                    flexDir={'column'}
                    justifyContent="space-between"
                    alignItems={'center'}
                    width={{ base: '320px', md: '320px' }}
                    height="235px"
                    gap="10px"
                    bg={'#FFF7E9'}
                    m="0 auto"
                    p="20px 25px"
                  >
                    <Box maxW={{ base: '235px', md: '235px' }}>
                      <Box
                        as="h3"
                        fontSize={{ base: '20px', md: '24px' }}
                        color="#000000"
                        lineHeight="26.28px"
                        textAlign={'center'}
                        fontFamily="FedraSansStd-book"
                        fontWeight={'bold'}
                        minH={'42px'}
                        m="0 auto"
                        width={{base:'205px', md:'100%'}}
                        // maxW={{base:'197px', md:'auto'}}
                      >
                        {secCon.title}
                      </Box>
                      <Box
                        className="desc-text"
                        textAlign={'center'}
                        fontFamily="FedraSansStd-book"
                        fontSize={'14px'}
                        maxW={'240px'}
                        m="10px auto 0 auto"
                        minH={'78px'}
                      >
                        {StructuredTextContent(secCon.description)}
                      </Box>
                    </Box>
                    <Box display="flex" justifyContent="center">
                      <NextLink
                        href={refineUrlDomain(secCon.buttonLink)}
                        passHref
                        legacyBehavior
                      >
                        <Link
                          display="block"
                          fontWeight={'500'}
                          fontFamily={'FedraSansStd-medium'}
                          fontSize={'14px'}
                          bgColor={secCon.sessions}
                          h={'45px'}
                          textAlign="center"
                          padding={'12px 20px'}
                          borderRadius="5px"
                          color="#ffffff"
                          textDecoration="none"
                          width={'240px'}
                          _hover={{ bg: 'fulvous' }}
                        >
                          {secCon.buttonText}
                        </Link>
                      </NextLink>
                    </Box>
                  </Flex>
                </Flex>
              );
            })}
          </Flex>
        </Box>
      </Box>
      <style>
        {`
        .desc-text p{
          color: #945607;
        }
        .rowContainer {
           padding: 0;
        }
        @media (max-width: 768px) {
          .funactivities h2 {
            font-size: 24px;
          }
          .rowContainer {
              margin: 0 auto !important;
          }
        }
        `}
      </style>
    </Box>
  );
};

export default FunActivities;
